import React, {useEffect, useState} from 'react'
import {TradeShowLayout} from '../../pages/tradeShow/TradeShowLayout'
import {FormattedMessage, useIntl} from 'react-intl'
import LanguageToggle from '../common/components/LanguageToggle'
import {Button, InputTextFormik} from '../../../_gori/partials/widgets'
import UseYupValidate from '../../../_gori/hooks/UseYupValidate'
import AuthService from '../auth/core/_requests'
import {toast} from 'react-toastify'
import * as Yup from 'yup'
import {isEmpty, isUndefined, lowerCase, startCase} from 'lodash'
import {useFormik} from 'formik'
import {AcceptTermCheckboxFormik} from '../../../_gori/partials/widgets/form/AcceptTermCheckboxFormik'

const KMat26Form: React.FC = () => {
  const intl = useIntl()
  const {stringYup, infoYup, regexYup} = UseYupValidate()
  const [loading, setLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)

  const registrationSchema = Yup.object().shape({
    company_name: stringYup(50, 'COMPANY_NAME')
      .trim()
      .matches(/^(?!\s)(?=.*\S$)[a-zA-Z0-9\s]+$/, {
        message: intl.formatMessage(
          {id: 'INPUT_MUST_CONTAIN_LETTERS_DIGITS_SPACES'},
          {input: intl.formatMessage({id: 'COMPANY_NAME'})}
        ),
        excludeEmptyString: true,
      }),
    name: regexYup.inputText('Name', true, 50),
    email: infoYup.email(),
    receive_emails: Yup.bool().oneOf([true], intl.formatMessage({id: 'REQUIRED'})),
  })

  const initialValues = {
    company_name: '',
    name: '',
    email: '',
    receive_emails: false,
  }

  const handleSubmitError = (errorsMessage: any) => {
    if (isEmpty(errorsMessage) || isUndefined(errorsMessage)) {
      return
    }

    Object.entries(errorsMessage).forEach(([key, value]: [any, any]) => {
      for (let i = 0; i < value.length; i++) {
        const errMessage = value[i].split('|')

        formik.errors[key] = formik.errors[key]
          ? formik.errors[key] +
            ', ' +
            intl.formatMessage({id: errMessage[1]}, {input: startCase(lowerCase(errMessage[0]))})
          : intl.formatMessage({id: errMessage[1]}, {input: startCase(lowerCase(errMessage[0]))})
      }
    })
  }

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const payload = {
          ...values,
          tags: 'kmat26',
        }
        const response = await AuthService.tradeShowSimple(payload)
        toast.success(intl.formatMessage({id: response.message}))
        setLoading(false)
        setSuccess(true)
        formik.resetForm()
      } catch (error: any) {
        setLoading(false)
        handleSubmitError(error?.response?.data?.error?.fields)
      }
    },
  })
  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(false)
      }, 5000)
    }
    // eslint-disable-next-line
  }, [success])

  return (
    <TradeShowLayout>
      <h1 className='card-title text-center pretendard mb-12'>
        {intl.formatMessage({id: 'CILF2025_TITLE'})}
      </h1>
      {success ? (
        <div
          className='w-100 rounded shadow-sm p-4 p-md-5 p-lg-10'
          style={{
            maxWidth: '500px',
            backgroundColor: '#ECFFFD99',
          }}
        >
          <div className='p-6'>
            <div className={'text-center my-6'}>
              <p style={{fontSize: '36px', fontWeight: 'bold'}}>
                {intl.formatMessage({id: 'YOUR_ALL_SET'})}
              </p>
              <img
                src='/media/gori/orders/delivery-completed.gif'
                alt=''
                className='img-fluid w-25 w-md-2 w-lg-auto'
              />
            </div>
          </div>
        </div>
      ) : (
        <div className='card border-radius-10 w-100'>
          <div className='card-body'>
            <div className='mb-6'>
              <InputTextFormik
                className={'mb-4'}
                labelClassName='form-label fw-bolder text-dark fs-6'
                label={intl.formatMessage({id: 'EMAIL'})}
                size='lg'
                formik={formik}
                name='email'
                required
                disabled={formik.isSubmitting}
              />
              <InputTextFormik
                className={'mb-4'}
                labelClassName='form-label fw-bolder text-dark fs-6'
                label={intl.formatMessage({id: 'NAME'})}
                size='lg'
                formik={formik}
                name='name'
                required
                disabled={formik.isSubmitting}
              />
              <InputTextFormik
                className={'mb-4'}
                labelClassName='form-label fw-bolder text-dark fs-6'
                label={intl.formatMessage({id: 'COMPANY_NAME'})}
                size='lg'
                formik={formik}
                name='company_name'
                required
                disabled={formik.isSubmitting}
              />

              <AcceptTermCheckboxFormik
                formik={formik}
                className='mt-3 mb-4 border-0'
                labelClassName={'text-gray-700 text-wrap fs-7'}
                inputClassName={'border-0'}
                type='checkbox'
                name='receive_emails'
                disabled={formik.isSubmitting}
                label={
                  <FormattedMessage
                    id='TERMS_AND_CONDITIONS_TRADE_SHOW_KOREA'
                    values={{
                      terms: (chunks) => (
                        <a
                          href='https://shipbae.com/service-terms'
                          target='_blank'
                          rel='noopener noreferrer'
                          className={'text-primary text-decoration-underline fw-semibold'}
                        >
                          {chunks}
                        </a>
                      ),
                      conditions: (chunks) => (
                        <a
                          href='https://shipbae.com/privacy-policy'
                          target='_blank'
                          rel='noopener noreferrer'
                          className={'text-primary text-decoration-underline fw-semibold'}
                        >
                          {chunks}
                        </a>
                      ),
                    }}
                  />
                }
                required
              />
            </div>

            <Button
              className='btn btn-lg btn-primary w-100 rounded-pill'
              label={intl.formatMessage({id: 'SUBMIT'})}
              loadingText={intl.formatMessage({id: 'SUBMIT'})}
              loading={loading}
              disabled={loading}
              event={formik.submitForm}
              style={{backgroundColor: '#0B6D65'}}
            />
          </div>
        </div>
      )}
      <LanguageToggle />
    </TradeShowLayout>
  )
}

export {KMat26Form}
export default KMat26Form
